/**
 * @desc 导出
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EnvironmentalMonitoringExportRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/wap/monitoring/export',
    data,
  });
}

export function mock(
  data: defs.EnvironmentalMonitoringExportRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/mock/wap/monitoring/export',
    data,
  });
}
